import { render, staticRenderFns } from "./HorizontalSteps.vue?vue&type=template&id=85254730&scoped=true"
import script from "./HorizontalSteps.vue?vue&type=script&lang=js"
export * from "./HorizontalSteps.vue?vue&type=script&lang=js"
import style0 from "./HorizontalSteps.vue?vue&type=style&index=0&id=85254730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85254730",
  null
  
)

export default component.exports